<template>
  <div class="modelSteer" v-if="steerObj" >
    <div class="steerLeftText"
      :style="{
        width: steerObj.leftText.style.width,
        textAlign: steerObj.leftText.style.algin,
        marginLeft: steerObj.leftText.style.left,
        marginTop: steerObj.leftText.style.top}"
        v-if="steerObj.leftText">
      <template v-for="itemDesc of steerObj.leftText.value" >
        <b class="title" v-if="itemDesc.colorText" :style="{color: itemDesc.color, fontSize: itemDesc.fontSize}" :key="itemDesc.text">
          {{itemDesc.colorText}}
        </b>
        <span class="title" v-html="itemDesc.text" v-if="itemDesc.text" :key="itemDesc.text">
        </span>
        <img v-else-if="itemDesc.img" :src="itemDesc.img" :key="itemDesc.img" alt="">
      </template>
    </div>
    <template v-for="bg of steerObj.bg">
      <img class="steerbg"
        :key="bg.img"
        :src="bg.img"
        :style="{top: bg.style.top,
        left: bg.style.left,
        zIndex: bg.style.zIndex,
        width: bg.style.width,
        height: bg.style.height}">
    </template>
    <div class="steerModel"
      :style="{
        width: steerObj.middenText.style.width,
        marginLeft: steerObj.middenText.style.left,
        marginTop: steerObj.middenText.style.top,
        backgroundImage: 'url(' + steerObj.middenText.style.bg + ')'}"
      v-if="steerObj.middenText">
      <template v-for="itemDesc of steerObj.middenText.value">
        <p v-if="itemDesc.text" :key="itemDesc.text">
          {{itemDesc.text}}
        </p>
        <img v-else-if="itemDesc.img" :src="itemDesc.img" :key="itemDesc.img" alt="">
     </template>
    </div>
    <div class="button"
      :style="{padding: steerObj.buttonStyle.padding, top: steerObj.buttonStyle.top, textAlign: steerObj.buttonStyle.algin, width: steerObj.buttonStyle.width, float: steerObj.buttonStyle.float}">
      <el-button @click="nextSteer(steerIndex)">下一步</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      steerObj: null
    }
  },
  props: {
    qidList: {
      type: Array,
      default: () => { return [] }
    },
    steerIndex: {
      type: Number,
      default: 0
    },
    selectedQidSmall: {
      type: Number,
      default: 0
    },
  },
  watch: {
    selectedQidSmall() {
      this.nextSteer(-1)
    }
  },
  mounted() {
    this.nextSteer(-1)
  },
  methods: {
    nextSteer(index) {
      const steerIndex = index + 1
      this.qidList.find(item => {
        item.small.forEach(itemSon => {
          if (itemSon.id === this.selectedQidSmall) {
            this.steerObj = itemSon.steer[steerIndex]
          }
        })
      })
      this.$emit('update:steerIndex', steerIndex)
    }
  }
}
</script>
<style lang="less" scoped>
.modelSteer{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  padding-left: 100px;
  z-index: 100;
  .steerModel{
    // width: 60%;
    // height: 30%;
    padding: 50px 50px;
    position: relative;
    background-size: 100% 100%;
    background-position: center;
    margin-bottom: 40px;
    p{
      width: 100%;
      font-size: 18px;
      line-height: 40px;
      color: #000;
      // text-indent: 36px;
    }
  }
  .steerLeftText{
    width: 55%;
    padding: 50px 30px 50px 160px;
    color: #fff;
    text-align: left;
    b{
      font-size: 23px;
    }
    .title{
      display: inline-block;
      font-size: 16px;
      line-height: 40px;
    }
    img{
      height: 40px;
      margin: 0 10px;
      top: 15px;
      position: relative;
    }
  }
  .steerbg{
    position: absolute;
  }
  .button{
    width: 100%;
    text-align: center;
    padding: 0 60px 0 160px;
    position: relative;
    .el-button{
      width: 130px;
      height: 40px;
      padding: 0;
      color: #fff;
      background: transparent;
    }
    /deep/.el-button>span{
      font-size: 18px !important;
    }
  }
}
</style>
